<template>
  <div>
    <div style="margin-bottom: 18px;margin-top: 18px;">
      <label style="color: #333333">菜单名称：</label>
      <el-input v-model="menuName" placeholder="请输入菜单名称" suffix-icon="el-icon-search" style="width: 200px;" size="small"
                @keyup.enter.native="getData"></el-input>
      <el-button type="primary" style="margin-left: 15px;margin-top: 10px;" size="small" @click="getData">查询</el-button>
      <el-button type="success" style="margin-left: 15px;margin-top: 10px;" size="small" @click="reset">重置</el-button>
      </el-button>
    </div>
    <el-table :data="tableData" :header-cell-style="{background:'#f2f5fc',color:'#55555'}" border highlight-current-row
              @current-change="handleGoodsCurrentChange" ref="multipleTable">
      <el-table-column prop="id" align="center" label="ID" width="60">
      </el-table-column>
      <el-table-column prop="menuname" align="center" label="菜单名称" width="180">
      </el-table-column>
      <el-table-column prop="menucode" align="center" label="菜单名称" width="180" >
      </el-table-column>
      <el-table-column prop="menucomponent" align="center" label="菜单路径">
      </el-table-column>
      <el-table-column prop="menuicon" align="center" label="菜单图标" width="180">
      </el-table-column>
	  <el-table-column prop="createUser" align="center" label="创建人" width="180">
	  </el-table-column>
	  <el-table-column prop="createTime" align="center" label="创建时间" width="180">
	  	<template slot-scope="scope">
	  		{{utils.formatTime(scope.row.createTime)}}
	  	</template>
	  </el-table-column>
     
    </el-table>

    <div style="align-content: center;text-align: center;margin: 20px;">
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[2, 5, 10, 20]"
          :page-size="10"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
      </el-pagination>
    </div>

  </div>
</template>

<script>
export default {
  name: "GoodsMange",
  data() {
    let checkCount = (rule, value, callback) => {
      if (value > 9999) {
        callback("数量输入过大");
      } else {
        callback();
      }
    }
    return {
      
      tableData: [],
      pageSize: 10,
      page: 1,
      total: 0,
      menuName: "",
      remark: "",
      centerDialogVisible: false,
      btnText: "提 交",
      textTitle: "创建账号",
      GoodsTypeData: [],
      StorageData: [],
      UsersData: [],
      stroage: "",
      goodstype: "",
      goodsTitle: "",
      goodsDialogVisible: false,
      currentRow: {},
      user: JSON.parse(sessionStorage.getItem('CurUser')),
    }
  },
  beforeMount() {
    this.getData();
  },
  methods: {
    handleGoodsCurrentChange(val) {
      this.currentRow = val;
    },
    reset() {
      this.menuName = "";
    },
    handleSizeChange(val) {
      this.page = 1;
      this.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getData();
    },
    getData() {
      var that = this;
      var params = {
        "pageSize": this.pageSize,
        "pageNum": this.page,
        "param": {
          "menuName": this.menuName,
        }
      };
      this.utils.requestPost(this, "/menu/getMenuList", params, function (res, total) {
        that.tableData = res;
        that.total = total;
      });
    }
  }
}
</script>

<style scoped>

</style>